import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'sb-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass],
    standalone: true,
})
export class LoaderComponent {
    @Input() color?: 'blue' | 'white' = 'blue';
    @Input() isSmall?: boolean;
}
